class FormValidator {
  constructor(settings) {
    this.options = Object.assign({
      formsClass: '.form-class',
      fieldsClass: '.element-validation',
      errorClass: 'error',
      submitButton: '*[type=submit]',
      disableSubmit: false
    }, settings);

    this.forms = document.querySelectorAll(this.options.formsClass);

    this.forms.forEach(form => {
      if (form) {
        this.validateOnEntry(form);

        if (this.options.disableSubmit) {
          // Initially hide the submit button
          this._hideSubmit(form, true);
        } else {
          this.formSubmit(form);
        }
      }
    });
  }

  // Enable or disable submit button
  _hideSubmit(form, status) {
    const event = status ? "none" : "unset";
    const opacity = status ? "0.5" : "1";
    const submitBtn = form.querySelector(this.options.submitButton);
    if (submitBtn) {
      submitBtn.style.pointerEvents = event;
      submitBtn.style.opacity = opacity;
    }
  }

  // Handle form submit
  formSubmit(form) {
    form.addEventListener('submit', e => {
      form.querySelectorAll(this.options.fieldsClass).forEach(field => {
        if (!this.validateFields(field, form)) {
          e.preventDefault();
        }
      });
    });
  }

  // Validate fields on input
  validateOnEntry(form) {
    const formFields = form.querySelectorAll(this.options.fieldsClass);
    formFields.forEach(field => {
      field.addEventListener('input', event => {
        this.validateFields(field);
        if (this.options.disableSubmit) {
          this.validForm(form);
        }
      });
    });
  }

  // Check if form is valid
  validForm(parentForm) {
    let allFields = parentForm.querySelectorAll(this.options.fieldsClass);
    let emptyFields = [...allFields].filter(input => input.value.trim() === "");
    let errorFields = parentForm.querySelectorAll(`.${this.options.errorClass}`);

    if (errorFields.length || emptyFields.length) {
      this._hideSubmit(parentForm, true);
    } else {
      this._hideSubmit(parentForm, false);
    }
  }

  // Validate a single field
  validateFields(field) {
    // Validate email
    if (field.type === "email") {
      const re = /\S+@\S+\.\S+/;
      if (re.test(field.value)) {
        this.setStatus(field, "success");
        return true;
      } else {
        this.setStatus(field, "error");
        return false;
      }
    }

    // Validate phone number
    if (field.type === "tel") {
      const re = /^[0-9]{6,}$/;
      if (re.test(field.value)) {
        this.setStatus(field, "success");
        return true;
      } else {
        this.setStatus(field, "error");
        return false;
      }
    }

    // Validate checkbox
    if (field.type === "checkbox") {
      if (field.checked) {
        this.setStatus(field, "success");
        return true;
      } else {
        this.setStatus(field, "error");
        return false;
      }
    }

    // Check if field is not empty
    if (field.value.trim() === "") {
      this.setStatus(field, "error");
      return false;
    } else {
      this.setStatus(field, "success");
      return true;
    }
  }

  // Add or remove error class
  setStatus(field, status) {
    if (status === "success") {
      field.closest('div').classList.remove('parent-error');
      field.classList.remove(this.options.errorClass);
      return true;
    }

    if (status === "error") {
      field.closest('div').classList.add('parent-error');
      field.classList.add(this.options.errorClass);
      return false;
    }
  }
}

// Initialize with custom selector
const defaultForm = new FormValidator({
  formsClass: '.form-validation',
  disableSubmit: true
});
